import { PlayerAhoyCommonEvent } from "@javascripts/player_ahoy_common_event";
import { PlayerAhoyEvent } from "@javascripts/player_ahoy_event";
import { PlayerAhoyLivestreamEvent } from "@javascripts/player_ahoy_livestream_event";
import { PlayerEnvironment } from "@javascripts/player_environment";

export class PlayerAhoyUtil {
  static setAhoyEventGlobalProperties(data) {
    let globalData = {
      page: PlayerEnvironment.locationHref(),
      videopremier: data.isPremier(),
      referrer: PlayerEnvironment.referrer(),
      is_preview: data.preview(),
      cdn: data.cdnName(),
      embed: data.embed() === 'true',
      access_type: data.accessType()
    };

    if (data.userIsPremier()) {
      globalData.user_type = 'premier';
    }

    let globalLsData = { ...globalData }
    let globalVodData = { ...globalData }

    if (data.isVideo()) {
      if (data.filmId() != 0) {
        globalData.film_id = data.filmId()
        globalVodData.film_id = data.filmId()
      }

      if (data.seasonId() != 0) {
        globalData.season_id = data.seasonId()
        globalVodData.season_id = data.seasonId()
      }
    } else if (data.isLivestreaming()) {
      globalData.is_drm = data.drmEnabled()
      globalLsData.is_drm = data.drmEnabled()
    }
    
    PlayerAhoyEvent._globalAppendData = globalVodData;
    PlayerAhoyCommonEvent._globalAppendData = globalData;
    PlayerAhoyLivestreamEvent._globalAppendData = globalLsData;
  }
}